#import "./sales-automation-step-template.graphql"
#import "./sales-automation-task-template.graphql"

fragment TodoTemplateCard on TodoTemplate {
    ... on StepTemplate {
        ...SalesAutomationStepTemplate
    }
    ... on ClosedLeadTaskTemplate {
        ...SalesAutomationTaskTemplate
    }
}
